import React from "react"

import appData from '../../app.json'

import Logo from '../img/logo/logo-blue@3x.png'

import SocialButton from '../elements/SocialButton'



export default function FooterSocialRow ({data}) {

  const phone = (appData.phone).match(/\d+/g).join('');
  
  return (
    <div className="row d-flex justify-content-between">
      <div className="col-auto mb-lg-0 mb-3">
      
      <img src={Logo} width="315" height="67" className="align-top img-fluid logo" alt="STOKES Construction blue"></img>
      </div>
      <div className="col-lg-auto col-12">
      <div className="row d-flex justify-content-start justify-content-lg-end">
        <div className="col-auto mb-lg-0 mb-3">
          <div className="row no-gutters d-flex align-items-center">
            <div className="col-auto">
              <SocialButton icon="email" url={`mailto:${appData.email}`} />
            </div>
            <div className="col-auto bg-light align-self-stretch d-flex align-items-center">
              <div className="px-3 text-primary">{appData.email}</div>
            </div>
          </div>
        </div>
        <div className="col-auto mb-lg-0 mb-3">
          <div className="row no-gutters d-flex align-items-center">
            <div className="col-auto">
              <SocialButton icon="call" url={`tel:${phone}`} />
            </div>
            <div className="col-auto bg-light align-self-stretch d-flex align-items-center">
              <div className="px-3 text-primary">{appData.phone}</div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-auto">
          <div className="row d-flex flex-wrap">
          { (appData.facebook_url && appData.facebook_url !== '') ? (
            <div className="col-auto px-lg-2 mb-lg-0 mb-3">
              <div className="row no-gutters d-flex align-items-center">
                <div className="col-auto">
                <SocialButton icon="fb" url={appData.facebook_url} />
                </div>
              </div>
            </div>
          ) : ''}


          { (appData.twitter_url && appData.twitter_url !== '') ? (
            <div className="col-auto px-lg-2 mb-lg-0 mb-3">
              <div className="row no-gutters d-flex align-items-center">
                <div className="col-auto">
                <SocialButton icon="twitter" url={appData.twitter_url} />
                </div>
              </div>
            </div>
          ) : ''}

          { (appData.linkedin_url && appData.linkedin_url !== '') ? ( 
            <div className="col-auto px-lg-2 mb-lg-0 mb-3">
              <div className="row no-gutters d-flex align-items-center">
                <div className="col-auto">
                  <SocialButton icon="in" url={appData.linkedin_url} />
                </div>
              </div>
            </div>
          ) : ''}
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}